import { DisplayRule } from '../../types';

/**
 * Mapeamento de condições de regras de exibição para seus labels em português
 */
export const DISPLAY_RULE_CONDITIONS_MAP: Record<string, string> = {
  equals: 'igual a',
  notEquals: 'diferente de',
  contains: 'contém',
  notContains: 'não contém',
  greaterThan: 'maior que',
  lessThan: 'menor que',
  greaterOrEqual: 'maior ou igual a',
  lessOrEqual: 'menor ou igual a',
  isEmpty: 'vazia',
  isNotEmpty: 'não vazia',
};

/**
 * Mapeamento de ações de regras de exibição para seus labels em português
 */
export const ACTION_LABELS: Record<string, string> = {
  show: 'mostrar',
  hide: 'ocultar',
  require: 'tornar obrigatório',
  unrequire: 'tornar opcional',
  enable: 'habilitar',
  disable: 'desabilitar',
};

/**
 * Retorna o label de uma condição
 * @param condition - A condição a ser traduzida
 * @returns O label em português ou string vazia se não encontrado
 */
export function getConditionLabel(condition: string): string {
  return DISPLAY_RULE_CONDITIONS_MAP[condition] || '';
}

/**
 * Retorna o label de uma ação
 * @param action - A ação a ser traduzida
 * @returns O label em português ou string vazia se não encontrado
 */
export function getActionLabel(action: string): string {
  return ACTION_LABELS[action] || '';
}

/**
 * Formata a descrição de uma regra de exibição
 * @param rule - A regra de exibição
 * @returns A descrição formatada em português
 */
export function formatDisplayRuleDescription(rule: DisplayRule): string {
  const conditionLabel = getConditionLabel(rule.condition);
  const actionLabel = getActionLabel(rule.action);

  return `Se resposta ${conditionLabel} "${rule.value}", então ${actionLabel}`;
}

/**
 * Retorna as opções de condições formatadas para uso em Select
 * @returns Array de opções { label, value } para uso em componentes Select
 */
export function getConditionOptions() {
  return Object.entries(DISPLAY_RULE_CONDITIONS_MAP).map(([value, label]) => ({
    label: label.charAt(0).toUpperCase() + label.slice(1), // Capitaliza a primeira letra
    value,
  }));
}
